// extracted by mini-css-extract-plugin
module.exports = {"emptyBlock":"EmptyBlock_emptyBlock__1zRfh","image":"EmptyBlock_image__2m86Q","description":"EmptyBlock_description__3Oo66"};